import styled, { css } from 'styled-components';
import { colors } from '@ardoq/design-tokens';

export const GroupLabel = styled.div<{
  $isDisabled?: boolean;
}>`
  flex: 1;
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      color: ${colors.textDisabled};
      user-select: none;
    `}
`;
